module.exports = __webpack_public_path__ + "static/media/aREP-logo.7ba73379.png";